import React from "react";
import { ArrowUpRight } from "lucide-react";
import { SQUADRE } from "../../data/content";
import Reveal from "./Reveal";

export const Squadre = () => (
  <section id="squadre" data-testid="squadre-section" className="bg-cream py-20 md:py-32">
    <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <div>
          <p className="font-sub uppercase tracking-[0.3em] text-court font-bold text-sm mb-4">
            Le Squadre
          </p>
          <h2 className="font-heading uppercase leading-[0.9] text-navy text-4xl md:text-6xl tracking-tight">
            Dal parquet dei grandi<br />ai campioni di domani
          </h2>
        </div>
        <p className="font-sub uppercase tracking-wide text-navy text-xl md:text-2xl font-bold leading-snug max-w-md border-l-4 border-court pl-5">
          Sei formazioni, un unico <span className="text-court">spirito biancoblù</span>. Trova la categoria giusta per te.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {SQUADRE.map((s, i) => (
          <Reveal key={s.name} delay={0.05 * (i % 3)}>
            <div
              data-testid={`squadra-card-${i}`}
              className="group bg-navy text-white border-4 border-navy p-8 h-full flex flex-col justify-between rounded-none transition-all duration-300 hover:bg-court hover:-translate-y-1 cursor-default"
            >
              <div className="flex items-start justify-between">
                <span className="font-heading text-5xl md:text-6xl text-gold group-hover:text-white transition-colors">
                  {s.cat}
                </span>
                <ArrowUpRight className="text-white/50 group-hover:text-white transition-colors" size={28} />
              </div>
              <div className="mt-16">
                <h3 className="font-sub uppercase font-bold text-xl tracking-wide">{s.name}</h3>
                <div className="font-sub uppercase text-xs tracking-widest text-white/60 group-hover:text-white/80 mt-1">
                  {s.league}
                </div>
                <p className="font-body text-sm text-white/70 group-hover:text-white/90 mt-4 leading-relaxed">
                  {s.desc}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Squadre;
